<template>
    <div class="multicard-layout">
        <slot/>
    </div>
</template>

<script>
    import BasicCard from "./BasicCard";
    export default {
        name: "MultiCardLayout",
        components: {BasicCard},
        data: function () {
            return {}
        }
    }
</script>

<style lang="scss" scoped>
    .multicard-layout {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
        grid-auto-rows: 1fr;
        grid-gap: 20px;
        position: relative;
    }
</style>